import { render, staticRenderFns } from "./filtersView.vue?vue&type=template&id=26b520db&scoped=true&"
import script from "./filtersView.vue?vue&type=script&lang=js&"
export * from "./filtersView.vue?vue&type=script&lang=js&"
import style0 from "./filtersView.vue?vue&type=style&index=0&id=26b520db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b520db",
  null
  
)

export default component.exports